import { Injectable } from '@angular/core';
import { errorData } from 'src/assets/data/error_coding';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  public message!: string;
  public errors = errorData;

  public lookupErrorMessageForID(errorID: any){
    const message = (this.errors as any)[errorID]["message"];
    return message;
  }

}
